var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"chartdata":this.chartdata,"options":this.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }